import * as React from 'react';
import classnames from 'classnames';
import { Price } from '@grandvisionhq/common';

var LabelPosition;
(function(LabelPosition) {
    LabelPosition["Left"] = 'left';
    LabelPosition["Right"] = 'right';
})(LabelPosition || (LabelPosition = {}));
const PriceAside = ({ value , currency , discountValue , asideLabel , asideLabelPosition =LabelPosition.Right ,  })=>{
    if (!value) return null;
    const isZeroPercentDiscount = value === discountValue;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, asideLabel && asideLabelPosition === LabelPosition.Left && /*#__PURE__*/ React.createElement("span", {
        className: "contact-lens-configurator__reminder"
    }, asideLabel, " "), /*#__PURE__*/ React.createElement(Price, {
        value: value,
        currency: currency,
        className: classnames('contact-lens-configurator__pack-size-price', {
            'contact-lens-configurator__pack-size-price--original': discountValue && !isZeroPercentDiscount
        })
    }), discountValue && !isZeroPercentDiscount && /*#__PURE__*/ React.createElement(Price, {
        value: discountValue,
        currency: currency,
        className: "contact-lens-configurator__pack-size-price contact-lens-configurator__pack-size-price--discounted"
    }), asideLabel && asideLabelPosition === LabelPosition.Right && /*#__PURE__*/ React.createElement("span", {
        className: "contact-lens-configurator__reminder"
    }, " ", asideLabel));
};

export { LabelPosition, PriceAside };
//# sourceMappingURL=PriceAside.js.map
